import { OutlinedRadioInput } from "@brexhq/component-library";
import * as React from "react";

import { useFormSubmissionContext } from "@brexhq/next/src/components/modules/LeadForm/FormSubmissionProvider";
import { LeadFormSteps } from "@brexhq/next/src/components/modules/LeadForm/machines/types";
import {
  LeadFormValues,
  StepProps,
} from "@brexhq/next/src/components/modules/LeadForm/sharedTypes";

import { employeeCountOptionsOBS4 } from "../../helpers/leadFormFields";
import { getStepProgress } from "../../machines/helpers";
import { SalesPageTemplate } from "../PageTemplates/SalesPageTemplate";

export const EmployeeCount: React.FC<StepProps> = () => {
  const {
    submitError,
    submit,
    prev,
    stepTransitionDirection,
    stateMachineCtx,
    form: { fields, programName, setProgress, getValues, currentState },
  } = useFormSubmissionContext();

  React.useEffect(() => {
    setProgress(getStepProgress(stateMachineCtx, currentState));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validFields = !!getValues("employeeCount");
  const onSubmit = React.useCallback(
    async (event) => {
      /**
       * List of fields used for this form. Most will have 1 field.
       * Type safe so the string fieldNames are based off FormValues
       */
      const fieldList: (keyof LeadFormValues)[] = ["employeeCount"];
      /**
       * Handles form submission including validations.
       * Reference FormSubmissionProvider.tsx for more context
       */
      submit({
        event,
        fields: fieldList,
        prevStep: LeadFormSteps.employeeCount,
      });
    },
    [submit],
  );

  const onPrev = React.useCallback(() => {
    prev("employeeCount");
  }, [prev]);

  return (
    <SalesPageTemplate
      title="How many employees do you have?"
      step={LeadFormSteps.employeeCount}
      programName={programName}
      nextAction={{
        label: "Continue",
        loading: false,
        disabled: !validFields,
        onClick: onSubmit,
      }}
      prevAction={{
        label: "Back",
        onClick: onPrev,
      }}
      stepTransitionDirection={stepTransitionDirection}
      error={submitError}
    >
      <>
        <OutlinedRadioInput
          {...fields.employeeCount}
          name="employeeCount"
          size="large"
          options={employeeCountOptionsOBS4}
        />
      </>
    </SalesPageTemplate>
  );
};
